// Generated by Claude Code
import { MetersPage } from '#components/domain/operations/meters/meters-page.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { readAnyGroups } from '#core/entities/auth/roles/permission-gate-helpers.ts'
import { createFileRoute } from '@tanstack/react-router'

/** Search params for the meters page. `asset` deep-links a view filtered to one asset. */
interface MetersSearch {
  asset?: string
}

export const Route = createFileRoute('/_app/$companyId/meters/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): MetersSearch => ({
    asset: typeof search.asset === 'string' ? search.asset : undefined,
  }),
  staticData: {
    title: 'Meters',
  },
})

function RouteComponent() {
  // Limited readers (any READ_LIMITED slot) may enter; the backend + limited-
  // access whitelists decide which properties they actually see.
  return (
    <PermissionGuard permissions={readAnyGroups(PermissionService.METERS)} redirectOnNotAuthorized>
      <MetersPage />
    </PermissionGuard>
  )
}
